import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSortAmountUpAlt,
  faSortAmountDown,
} from '@fortawesome/free-solid-svg-icons';

export const SortIndicator = ({
  name,
  sortBy,
  sortDirection,
}: {
  name: string;
  sortBy: string;
  sortDirection: 'asc' | 'desc';
}) => {
  if (name !== sortBy) {
    return null;
  } else {
    return sortDirection === 'asc' ? (
      <FontAwesomeIcon icon={faSortAmountUpAlt} size="1x" fixedWidth />
    ) : (
      <FontAwesomeIcon icon={faSortAmountDown} size="1x" fixedWidth />
    );
  }
};
